import {
  ChatIcon,
  ClockIcon,
  CommentIcon,
  IssueIcon,
  KeypadIcon,
  MicIcon,
  PeopleIcon,
  VoicemailIcon,
} from '@sharedCR/coreDesignSystem/icons';

import { RenderingContainerType } from 'constants/telephony';

export const TELEPHONY_WIDGET_WIDTH = 380;
export const TELEPHONY_WIDGET_HEIGHT = 550;
export const ACTIVE_TAB_STORAGE_KEY = 'telephony_active_tab';

export const TAB_CONFIG = [
  {
    key: RenderingContainerType.CONTACTS,
    label: 'Contacts',
    Icon: PeopleIcon,
  },
  {
    key: RenderingContainerType.TEXT_SMS,
    label: 'Text/SMS',
    Icon: IssueIcon,
  },
  {
    key: RenderingContainerType.KEYPAD,
    label: 'Keypad',
    Icon: KeypadIcon,
  },
  {
    key: RenderingContainerType.HISTORY,
    label: 'History',
    Icon: ClockIcon,
  },
  {
    key: RenderingContainerType.CHAT,
    label: 'Chat',
    Icon: CommentIcon,
  },
  {
    key: RenderingContainerType.INTERNAL_CHAT,
    label: 'Internal Chat',
    Icon: ChatIcon,
    hasBadge: true,
  },
  {
    key: RenderingContainerType.VOICEMAILS,
    label: 'Voicemail',
    Icon: VoicemailIcon,
  },
  {
    key: RenderingContainerType.RECORDINGS,
    label: 'Recordings',
    Icon: MicIcon,
    requiredRoles: ['loanofficer'],
  },
];

export const PLACEHOLDER_ICON_SIZE = 48;
